import React from "react";

import { Input } from "../Input";

import { IInputOnChange } from "../../interfaces/input";
import { ICodeProps } from "../../interfaces/code";

import * as S from "./styles";

export const Code: React.FC<ICodeProps> = ({
  length,
  onComplete,
  ...props
}) => {
  const onChange: IInputOnChange = (name, value) => {
    !!props.onChange && props.onChange(name, value);

    if (value.length === length) {
      onComplete(value);
    }
  };

  return (
    <S.Wrapper>
      <Input
        {...props}
        onChange={onChange}
        inputMode="numeric"
        maxLength={length}
      />
    </S.Wrapper>
  );
};
